import { render } from "./2TeamFilter.vue?vue&type=template&id=9a7265d6&scoped=true"
import script from "./2TeamFilter.vue?vue&type=script&lang=js"
export * from "./2TeamFilter.vue?vue&type=script&lang=js"

import "./2TeamFilter.vue?vue&type=style&index=0&id=9a7265d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a7265d6"]])

export default __exports__